import moment from "moment"

const timeLimitEnv = process.env.REACT_APP_ORDER_TIME_LIMIT

var minutesOfDay = function(m: moment.Moment){
  return m.minutes() + m.hours() * 60;
}

const useOrderDates = (timeLimit?: Date) => {
  const minDate = () => {
    const now = moment()

    const addDays = timeLimit 
      ? minutesOfDay(now) >= minutesOfDay(moment(timeLimit)) ? 2 : 1
      : now.hours() >= Number(timeLimitEnv) ? 2 : 1

    return moment().startOf('day').add(addDays, 'days').toDate()
  }
  
  const maxDate = () => moment().startOf('day').add(1, 'years').toDate()

  const isValid = (value: string | Date): boolean => {
    const date = moment(value)

    return date.isSameOrAfter(moment(minDate()))
        && date.isSameOrBefore(moment(maxDate()))
  }

  const isValidByDate = (value: Date): boolean => {
    const date = moment(value)

    return date.isSameOrAfter(moment(minDate()))
        && date.isSameOrBefore(moment(maxDate()))
  }

  // const toString = (value: Date, withTime?: boolean): string => {
  //   moment()
  // }

  return {
    minDate,
    maxDate,
    isValid,
    isValidByDate
  }
}

export {useOrderDates}